import React from "react"
import { OverlayTrigger } from "react-bootstrap"

import { Empty, PencilIcon } from "client/components"
import {
    PopoverWrapper,
    PopoverStyled,
    PopoverContentStyled,
    PopoverTitleWrapper,
    PopoverTitle,
    PopoverContentRow,
    PopoverRowProps,
} from "./styled"


export interface TablePopoverData {
    id: string
    title: any
}

export interface TablePopoverProps extends PopoverRowProps {
    id: string
    dataList: TablePopoverData[]
    placement?: "left" | "right"
    title: string
    showFirst?: boolean
    editAccess?: boolean
    onClick?: () => void
}

export const TablePopover = ({
    id = null,
    dataList = [],
    placement = "left",
    title = "",
    showFirst = true,
    listStyle = true,
    editAccess = true,
    onClick = null,
}: TablePopoverProps) => {
    if (!dataList.length) {
        return (
            <PopoverWrapper onClick={editAccess ? onClick : null}>
                <PopoverTitleWrapper>
                    <Empty />
                    {editAccess && <PencilIcon />}
                </PopoverTitleWrapper>
            </PopoverWrapper>
        )
    }

    const count = (dataList.length > 1) ? `(${dataList.length} ${title}) ` : ""
    return (
        <PopoverWrapper onClick={editAccess ? onClick : null}>
            <OverlayTrigger
                trigger={["hover", "focus"]}
                placement={placement}
                overlay={(
                    <PopoverStyled id={id} placement={placement}>
                        <PopoverContentStyled>
                            {
                                dataList.map((item) => (
                                    <PopoverContentRow
                                        key={item.id}
                                        listStyle={listStyle}
                                    >
                                        {item.title}
                                    </PopoverContentRow>
                                ))
                            }
                        </PopoverContentStyled>
                    </PopoverStyled>
                )}
            >
                <PopoverTitleWrapper>
                    <PopoverTitle>
                        {count}
                        {showFirst && dataList[0].title}
                    </PopoverTitle>
                    {editAccess && <PencilIcon />}
                </PopoverTitleWrapper>
            </OverlayTrigger>
        </PopoverWrapper>
    )
}
